import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  transactionDropdown: {
    marginLeft: '4px'
  }
});
export default useStyles;